<template>
  <div class="mainContent">
    
    <div class="mainContent__field">
      <label for="status_to_send">
        Status para enviar pedido (PLP)
        <sc-tooltip
          type="is-light"
          position="is-left"
          label="Status do TMS"
        >
          <sc-icon size="is-small" icon="info-circle" />
        </sc-tooltip>
      </label>
      <div class="editable">
        <sc-multiple-selection
          :hasActions="false"
          :options="status_to_send_options"
          v-model="value.psl_volume_states_to_send"
          @input="updateField('psl_volume_states_to_send', $event)"
          :disabled="disable_flags.status_to_send"
        >
        </sc-multiple-selection>

        <sc-button icon="pen" theme="default" size="small"
          v-if="disable_flags.status_to_send"
          @click="showConfirmationDialog('status_to_send')"
        />
      </div>
    </div>

    <div class="mainContent__field">
      <label for="status_after">
        Status após o envio
        <sc-tooltip
          type="is-light"
          position="is-left"
          label="Status do TMS"
        >
          <sc-icon size="is-small" icon="info-circle" />
        </sc-tooltip>
      </label>
      <div class="editable">
        <sc-select 
          class="span__select" 
          v-model="value.psl_volume_state_after_sent" 
          @input="updateField('psl_volume_state_after_sent', $event)"
          :disabled="disable_flags.status_after">
          <option v-for="status in status_after_options" :key="status.id" :value="status.value">
            {{ status.label }}
          </option>
        </sc-select>

        <sc-button icon="pen" theme="default" size="small"
          v-if="disable_flags.status_after"
          @click="showConfirmationDialog('status_after')"
        />
      </div>
    </div>

    <div class="mainContent__field">
      <label for="psl_trigger_selected">
        Opção de envio
        <sc-tooltip
          type="is-light"
          position="is-left"
          label="Na criação do pedido"
        >
          <sc-icon size="is-small" icon="info-circle" />
        </sc-tooltip>
      </label>
      <div class="editable">
        <sc-select 
          class="span__select" 
          v-model="value.psl_trigger_selected"  
          :disabled="disable_flags.psl_trigger_selected"
          @input="updateField('psl_trigger_selected', $event)">
          <option  v-for="status in psl_trigger_selected_options" :key="status.id" :value="status.value">
            {{ status.label }}
          </option>
        </sc-select>

        <sc-button icon="pen" theme="default" size="small"
          v-if="disable_flags.psl_trigger_selected"
          @click="showConfirmationDialog('psl_trigger_selected')"
        />
      </div>
    </div>

    <div class="mainContent__field" v-if="value && value.psl_trigger_selected === 'cut_times'">
      <label for="psl_trigger_cut_times">
        Horários de envio
        <sc-tooltip
          type="is-light"
          position="is-left"
          label="Janela de envio"
        >
          <sc-icon size="is-small" icon="info-circle" />
        </sc-tooltip>
      </label>
      <sc-multiple-selection
        :hasActions="false"
        :options="psl_trigger_cut_times_options"
        v-model="value.psl_trigger_cut_times"
        @input="updateField('psl_trigger_cut_times', $event)"
        :disabled="disable_flags.psl_trigger_cut_times"
      >
      </sc-multiple-selection>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScInput,
    ScToast,
    ScTooltip,
    ScIcon,
    ScSelect,
    ScMultipleSelection,
    ScDialog,
  } from '@intelipost-js/secure-components';

  const { mapMutations } = createNamespacedHelpers(
    'integrations/integrationsAppSelfService',
  );

  export default {
    name: 'sc-sysnode-commons',
    components: {
      ScButton,
      ScField,
      ScInput,
      ScToast,
      ScTooltip,
      ScIcon,
      ScSelect,
      ScMultipleSelection,
      ScDialog,
    },
    props: {
      value: {
        type: Object,
        required: false,
      },
      warehouseId: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        disable_flags: {
          status_to_send: true,
          status_after: true,
          psl_trigger_selected: true,
          psl_trigger_cut_times: false,
        },
        status_to_send_options: [
          {
            value: 1,
            label: '1 - Criado',
          },
          {
            value: 6,
            label: '6 - Etiqueta Criada',
          },
          {
            value: 8,
            label: '8 - Pronto para Despacho',
          },
          {
            value: 9,
            label: '9 - Despachado',
          },
        ],

        status_after_options: [
          {
            value: 8,
            label: '8 - Pronto para Despacho',
          },
          {
            value: 9,
            label: '9 - Despachado',
          },
        ],
        psl_trigger_selected_options: [
          {
            value: '',
            label: 'Na criação do pedido',
          },
          {
            value: 'cut_times',
            label: 'Em horários específicos',
          },
        ],
        psl_trigger_cut_times_options: [
          { value: '00:00', label: '00:00' },
          { value: '01:00', label: '01:00' },
          { value: '02:00', label: '02:00' },
          { value: '03:00', label: '03:00' },
          { value: '04:00', label: '04:00' },
          { value: '05:00', label: '05:00' },
          { value: '06:00', label: '06:00' },
          { value: '07:00', label: '07:00' },
          { value: '08:00', label: '08:00' },
          { value: '09:00', label: '09:00' },
          { value: '10:00', label: '10:00' },
          { value: '11:00', label: '11:00' },
          { value: '12:00', label: '12:00' },
          { value: '13:00', label: '13:00' },
          { value: '14:00', label: '14:00' },
          { value: '15:00', label: '15:00' },
          { value: '16:00', label: '16:00' },
          { value: '17:00', label: '17:00' },
          { value: '18:00', label: '18:00' },
          { value: '19:00', label: '19:00' },
          { value: '20:00', label: '20:00' },
          { value: '21:00', label: '21:00' },
          { value: '22:00', label: '22:00' },
          { value: '23:00', label: '23:00' },
        ],
      };
    },
    mounted() {
      this.applyDefaultValues();
      this.saveFieldsToAppConfig();
    },
    watch: {
      value: {
        handler() {
          this.applyDefaultValues();
        },
        deep: true,
      },
    },
  
    methods: {
      ...mapMutations([
        'setAppConfigField',
      ]),
      showConfirmationDialog(disableFlagName) {
        ScDialog.confirm({
          title: 'Confirmação',
          message: 'Estes valores são recomendados pela Intelipost. Tem certeza que deseja alterar?',
          confirmText: 'Sim, desejo alterar',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          onConfirm: () => {
            this.disable_flags[disableFlagName] = false;
          },
        });
      },
      validateConfig() {
        return true;
      },
      applyDefaultValues() {
        const defaultValue = {
          psl_volume_states_to_send: [1, 8, 9],
          psl_volume_state_after_sent: 9,
          psl_trigger_selected: '',
          psl_trigger_cut_times: [],
        };

        Object.keys(defaultValue).forEach((key) => {
          if (!(key in this.value)) {
            this.$set(this.value, key, defaultValue[key]);
            this.saveFieldToAppConfig(key, defaultValue[key]);
          }
        });
      },
      updateField(fieldName, value) {
        this.$set(this.value, fieldName, value);
        this.saveFieldToAppConfig(fieldName, value);
      },
      saveFieldToAppConfig(fieldName, fieldValue) {
        const warehouseId = this.warehouseId;
        const appConfigSection = 'sysnode';

        this.setAppConfigField({
          app_config_section: appConfigSection,
          warehouseId,
          fieldName,
          fieldValue,
        });
      },
      saveFieldsToAppConfig() {
        this.saveFieldToAppConfig('psl_volume_states_to_send', this.value.psl_volume_states_to_send);
        this.saveFieldToAppConfig('psl_volume_state_after_sent', this.value.psl_volume_state_after_sent);
        this.saveFieldToAppConfig('psl_trigger_selected', this.value.psl_trigger_selected);
        this.saveFieldToAppConfig('psl_trigger_cut_times', this.value.psl_trigger_cut_times);
      },
    },
  };
</script>
<style lang='scss' scoped>

.mainContent {
  display: flex;
  flex-direction: column;
  gap: 30px;

  &__labels {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
}

  .editable {
    display: flex;
    align-items: center;
    justify-content: center;

    & > :first-child {
      flex-grow: 1;
    }
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/sysnode/ScSysnodeCommons.vue